export default "__VITE_ASSET__ckvjjxur__"